import type { ISbRichtext } from "gatsby-source-storyblok";

import Button from "../../../Button";

import type { FC } from "react";
import RichText from "../../../RichText/RichText";
import * as s from "./TabContent.module.scss";

type TabContentProps = {
	header?: string;
	content?: string | ISbRichtext;
	cta?: { label: string; link: string };
};

const TabContent: FC<TabContentProps> = ({ header, content, cta }) => {
	return (
		<div className={s.container}>
			{header && <h3 className={s.header}>{header}</h3>}
			{content && <RichText content={content} />}
			{cta && (
				<Button
					variant="secondary"
					href={cta.link}
					label={cta.label}
					icon="arrow-right"
				/>
			)}
		</div>
	);
};

export default TabContent;
